// ─────────────────────────────────────────────────────────────────────────────
// THE INVOICE LINE A BILLABLE EXPENSE BECOMES — the invoice form's copy of the rule.
//
// THE TWIN OF "Aidey Backend/lib/expenseRebill.js" (the Intelligence auto_create_invoice), and
// deliberately a copy, because the browser cannot require a backend file. Both are pinned to the
// same committed table, "Aidey Backend/ci/expense_rebill_cases.json", by expenseRebill.test.js here
// and tests/expenseRebill.test.js there, so editing one rule without the other fails a test.
//
// Carla, 2026-10-20: re-billing charged VAT twice when a receipt's VAT-inclusive total went into a
// field labelled only "Amount". An expense amount is its NET amount, EXCLUDING VAT (the expense
// form's "Total inc. VAT" is amount + VAT; the Tax and VAT summaries reclaim amount x rate), and
// the field now says so. The line is that net amount, quantity 1, with the VAT added ONCE at the
// line's rate: the business's chosen rate when given, else the expense's own.
// ─────────────────────────────────────────────────────────────────────────────

import { roundMinor } from './invoiceAmounts';
import { rateTypeForPercent } from './vatRates';

function num(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

export function expenseNet(expense) {
  return num(expense && expense.amount);
}

export function expenseRebillLine(expense, opts) {
  const chosen = opts && opts.rate !== undefined && opts.rate !== null && opts.rate !== '';
  const description = `${(expense && expense.title) || 'Expense'} (expense)`;
  const rate = num(chosen ? opts.rate : expense && expense.tax_rate);
  // Item 34: NOT VAT REGISTERED, the VAT it paid is part of its cost (it cannot reclaim it), and its
  // invoices may not charge VAT: the line is the gross, at no VAT, so the client's total is the same.
  if (opts && opts.registered === false) {
    const ownRate = num(expense && expense.tax_rate);
    return { description, qty: 1, unitPrice: roundMinor(expenseNet(expense) * (1 + ownRate / 100), 'GBP'), tax: 0 };
  }
  // Registered: the line names its rate TYPE when the percent can only mean one (20, 5).
  const type = rateTypeForPercent(rate);
  return { description, qty: 1, unitPrice: expenseNet(expense), ...(type ? { rateType: type } : {}), tax: rate };
}
